import types from '@/vuex/juntada/mutations-types'

const mutations = {
  [types.SET_PASSO_ATUAL]: (state, payload) => {
    state.passoAtual = payload.passoAtual
  },
  [types.SET_LISTA_DOCUMENTOS]: (state, payload) => {
    state.listaDocumentos = payload.listaDocumentos
  },
  [types.SET_TIPO_JUNTADA_SELECIONADA]: (state, payload) => {
    state.tipoJuntadaSelecionada = payload.tipoJuntadaSelecionada
  },
  [types.SET_DOCUMENTO_SELECIONADO]: (state, payload) => {
    state.documentoSelecionado = payload.documentoSelecionado
  }
}
export default mutations
